import React from 'react';
import { Avatar, AvatarSize } from 'wix-ui-tpa/cssVars';
import ProfileLink from '../profile-link/profile-link';
import AnonymousAvatar from '../anymous-avatar/anonymous-avatar';
import styles from './user-avatar.scss';
import { unreachable } from '../../../ts-utils';
export const UserAvatar = ({ className, owner, avatarSize = AvatarSize.medium }) => {
    return (React.createElement("div", { className: className }, (() => {
        var _a;
        switch (owner.type) {
            case 'MEMBER':
                const avatarUrl = (_a = owner.member.profile.photo) === null || _a === void 0 ? void 0 : _a.url;
                return (React.createElement(ProfileLink, { tabIndex: -1, member: owner.member },
                    React.createElement(Avatar, { className: styles.avatar, src: avatarUrl, size: avatarSize, name: avatarUrl && owner.member.profile.nickname
                            ? owner.member.profile.nickname
                            : undefined })));
            case 'ANONYMOUS':
                return (React.createElement(AnonymousAvatar, { size: avatarSize, className: styles.avatar, hexColor: `#${owner.identityId.substring(0, 6)}` }));
            case 'PLACEHOLDER':
            case 'UNKNOWN':
                return React.createElement(Avatar, { className: styles.avatar, size: avatarSize });
            default:
                throw unreachable(owner);
        }
    })()));
};
//# sourceMappingURL=user-avatar.js.map